<template>
    <div :class='isPC?"max-section":"pcmax-section"'>
        <!-- 艾多美 -->
        <!-- <video-Page :courseInfo="courseInfo"></video-Page> -->
        <div v-if='isPC' class='phoneClass'>
            <div class="video-content">
                <!-- 播放器实例 -->
                <div style='position:relative' :class='isPC?"video-phone":"pc-video"'>
                    <div :class='isPC?"absovideo-phone":"absopc-video"'>
                         <div id="play-con" v-show='livePlayerStatus == 2'></div>
                    </div>
                    <!-- 倒计时 和 直播结束 -->
                    <div id="playmask" class="playmask" :style="{backgroundImage:'url('+courseInfo.image+')'}" v-if="livePlayerStatus !=2">
                        <div class="bgcolor">
                            <!-- 直播未开始显示倒计时 -->
                            <p class="timer">{{countFownTime}}</p>
                            <!-- 直播已结束显示提示语 -->
                            <p class="playerStatus" >{{livePlayerStatus | playerStatusmsg }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 标题 -->
            <div class="title-atomy">
                <img src="https://cdn.youinsh.cn/p/enterprise_logo/enterprise_logo/1671199774ed664316d2b7d0d3d93b1b.jpg" alt="">
                <div>
                    <div><span class='title-atomy-msg-title'>{{courseInfo.title}}</span></div>
                    <div><span>{{utiljstime(courseInfo.start_time)}}</span></div>
                </div>
            </div>
            <div class="tab">
                <div class='tab-menu-list'>
                    <div 
                    @click="tabMenu(index,item)" 
                    v-for="(item,index) in menuTab" :key="'tab-'+index">
                        <span :class="tab.code == item.code?'tab-active':''" >{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div class='tab-box'> 
                <div class="tab-introduce tab-comtent" v-html="tab.content" v-show='isUserDefined'></div>
                <div v-show='tab.code == "chat"'>
                    <virtual-list 
                    :style="{'height':chatHeight+'px','overflow-y':'auto'}"
                    :data-key="'id'"
                    :data-sources="chatList" 
                    :data-component="itemComponent"
                    :keeps="10"
                    @scrollToBottom='scrollToBottom'
                    ref='virtualListTemple'
                    class='virtual-list'
                    :start='10'
                    />
                </div>
            </div>
            <div class="footer-chat" v-show='tab.code == "chat"'>
                <div class="footer-input">
                    <!-- 可以使用 CellGroup 作为容器 -->
                    <div class='icon-changename' @click='changeNickname'><van-icon name="user-circle-o" /></div>
                    <van-cell-group inset>
                        <van-field v-model="chatmsg" label="" :placeholder="isMgsDisable?'禁言中':'说点什么吧'" :disabled='isMgsDisable'/>
                    </van-cell-group>
                </div>
                <div class="footer-main">
                    <div class="footer-show-box">
                        <!-- <div class="up-pic">
                            <van-uploader class="updateimg-chat" :after-read="beforeUploadImg" :disabled='isMgsDisable'/>
                            <van-icon name="photo-o" class="update-img"/>
                        </div> -->
                        <div  @click='sendNews' class='send-msg'>发送</div>
                        <!-- <div>礼物</div> -->
                    </div>
                    <!-- <div></div> -->
                </div>
            </div>
        </div>
        <div v-if='!isPC' class='pclass'>
            <div class='pc-left'>
                <!-- 标题 -->
                <div class="title-atomy">
                    <img src="https://cdn.youinsh.cn/p/enterprise_logo/enterprise_logo/1671199774ed664316d2b7d0d3d93b1b.jpg" alt="">
                    <div>
                        <div><span class='title-atomy-msg-title'>{{courseInfo.title}}</span></div>
                        <div><span>{{utiljstime(courseInfo.start_time)}}</span></div>
                    </div>
                </div>
                <div class="video-content">
                    <!-- 播放器实例 -->
                    <div id="play-con" v-show='livePlayerStatus == 2'></div>
                    <!-- 倒计时 和 直播结束 -->
                    <div id="playmask" class="playmask" :style="{backgroundImage:'url('+courseInfo.image+')'}" v-if="livePlayerStatus !=2">
                        <div class="bgcolor">
                            <!-- 直播未开始显示倒计时 -->
                            <p class="timer">{{countFownTime}}</p>
                            <!-- 直播已结束显示提示语 -->
                            <p class="playerStatus" >{{livePlayerStatus | playerStatusmsg }}</p>
                        </div>
                    </div>
                
                </div>
                
            </div>
            <div class='pc-right'>
                <div class="tab">
                    <div class='tab-menu-list'>
                        <div 
                        @click="tabMenu(index,item)" 
                        v-for="(item,index) in menuTab" :key="'tab-'+index">
                            <span :class="tab.code == item.code?'tab-active':''" >{{item.name}}</span>
                        </div>
                    </div>
                </div>
                <div class='tab-box'> 
                    
                    <div class="tab-introduce tab-comtent" v-html="tab.content" v-show='isUserDefined'></div>
                    <div v-show='tab.code == "chat"'>
                        <virtual-list 
                        :style="{'height':chatHeight+'px','overflow-y':'auto'}"
                        :data-key="'id'"
                        :data-sources="chatList" 
                        :data-component="itemComponent"
                        :keeps="10"
                        @scrollToBottom='scrollToBottom'
                        ref='virtualListTemple'
                        class='virtual-list'
                        :start='10'
                        />
                    </div>
                </div>
                <div class="footer-chat" v-show='tab.code == "chat"'>
                    <div class="footer-input">
                        <!-- 可以使用 CellGroup 作为容器 -->
                        <div class='icon-changename' @click='changeNickname'><van-icon name="user-circle-o" /></div>
                        <van-cell-group inset>
                            <van-field v-model="chatmsg" label="" :placeholder="isMgsDisable?'禁言中':'说点什么吧'" :disabled='isMgsDisable'/>
                        </van-cell-group>

                    </div>
                    <div class="footer-main">
                        <div class="footer-show-box">
                            <!-- <div class="up-pic">
                                <van-uploader class="updateimg-chat" :after-read="beforeUploadImg" :disabled='isMgsDisable'/>
                                <van-icon name="photo-o" class="update-img"/>
                            </div> -->
                            <div  @click='sendNews' class='send-msg'>发送</div>
                            <!-- <div>礼物</div> -->
                        </div>
                        <!-- <div></div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 答题 -->
        <div>
            <prizeQA :totalRankList='totalRankList' @closeprizeQA='closeprizeQA' v-show='isShowAnswer' :winninganswer='winninganswer' :isShowAnswerRankingList='isShowAnswerRankingList' @changetypepage='changetypepage'></prizeQA>
        </div>
        <!-- 微信中打开 -->
        <div class='wechattips' v-if='isShowWX'>
            <img src="../../assets/img/mobiletip.png">
        </div>
        <!-- 小程序中打开 -->
        <div class='wechattips' v-if='isShowWXxcx'>
            <img src="https://atomy.youinsh.cn/img/mobiletip.png">
        </div>
        <!-- 答题榜icon -->
        <div class='dt_phb_box' v-if='isShowAnswerIcon' @click='showAnswerList'>
            <img src="../../assets/img/dt_phb.png" alt="">
        </div>
        <!-- 首次进入聊天没有昵称 -->
        <div class='userName-chat' v-if='isShowNickname'>
            <div class='username-pop'>
                <p class='user-pop-title'>{{nickNameTitle}}</p>
                <van-cell-group inset>
                    <van-field v-model="userInfo.nickname" label="" placeholder="如：姓名-009286" maxlength='16'/>
                </van-cell-group>
                <div class='usernamePrompt' v-if="isRemMsg">请在昵称后面加入个人真实<i>手机号后6位</i>，抽奖环节如果您中奖了，方便管理员确认您的真实身份。</div>
                <div class='usernamePrompt' v-if="!isRemMsg">请在昵称后面加入个人真实<i>手机号后6位</i>，方便管理员确认您真实身份。</div>
                <div class='nickname-sure'><span class='cancelNickname' @click='cancelNickname'>取消</span><span @click='nickNameChange'>确定</span></div>
            </div>
        </div>
        <!-- 黑名单 -->
        <div class='isBlackClass' v-if='isBlackNameList'>
            <div><img src="../../assets/img/PermissionDenied.png" alt=""></div>
            <div>抱歉，您无权观看此视频</div>
        </div>
        <!-- 加密 -->
        <div class='password-watch' v-if='passwordWatch'>
            <div class='username-pop'>
                <p class='user-pop-title'>该场直播为加密直播</p>
                <van-cell-group inset>
                    <van-field v-model="passwordCode" label="" placeholder="请输入密码"/>
                </van-cell-group>
                <div class='nickname-sure'><span @click='passWatch'>确定</span></div>
            </div>
        </div>
    </div>
</template>
<script>
import VirtualList from 'vue-virtual-scroll-list'
import VirtualChat from "../chat/virtualChat"
import { mapState, mapActions } from 'vuex'
import videoPage from "@/views/video/videoPage"
import prizeQA from "@/views/answer/prizeQA" //有奖问答
import chatJS from "../../assets/js/chatWatch"
import md5 from 'js-md5';
import { Toast } from 'vant';
const {
		Realtime,
		TextMessage,
		TypedMessagesPlugin,
		ImageMessage
	} = AV;
export default {
    data() {
        return{
            chatHeight:3,
            itemComponent:VirtualChat,
            courseInfo:{},
            websocket:null,
            currentUserId:null,
            userInfo:{
                id:null,
                nickname:null,
                headImageUrl:"https://cdn.youinsh.cn/saas_pro/static/user/user-default.png"
            },
            lockReconnect:false, //防止WebSocket 重复链接
            timerWebSocket:null, //防止WebSocket 重复链接 定时器
            leancloudConfig : {
                appId: "BL0eDKFkzB8qmoWMYFxdCWFf-gzGzoHsz",
                appKey: "Y2zyu6d0rUsxWNSaQKJDqQTk",
                serverURLs: 'https://leancloud.youinsh.com'
            },
            videoUrl:"",
            videoOption:null, //播放器参数
            nowDate:null,
            videoPlayer:null, //播放器实例
            content:null,
            recordTimer:null,
            countFownTime :"" , //倒计时
            livePlayerStatus:1 ,// 直播状态  1直播未开始 0直播已结束 2直播进行中
            menuTab:[],
            tab:{}, //tab切换
            chatmsg:"" , //聊天text
            isShowAnswer:false, //是否展示有奖问答
            answerPageType:null, //记录答题进行到哪一步了
            winninganswer:{}, //答题数据
            isShowWX:false, //判断是否在微信浏览器中  false不在
            isShowWXxcx:false ,//判断是否在微信小程序中 false不在
            isShowAnswerRankingList:false, //是否显示排行榜
            isShowAnswerIcon:false, //是否显示排行榜icon
            totalRankList:[] ,//发布答题榜以后 总排行
            courseJsonDate:{} , //直播信息，主要取 是否禁言
            chatList:[], // 聊天记录
            isShowNickname:false, //判断是否需要修改昵称弹出框
            isPC:false ,//是否是pc端 false pc
            isBlackNameList:false, //判断是否进入了黑名单 false未进入
            isUserDefined:false, // 是否是自定义菜单
            isMgsDisable:true,
            nickNameTitle:"输入昵称",
            passwordWatch:false, //密码观看  true开启
            passwordCode:'',
            isRemMsg:0, // 爱在线=1, 一日研讨会=0  修改昵称文案不同
        }
    },
    created(){
        this.isPC = this.isMobile()
    },
    mounted(){
        document.addEventListener('visibilitychange', this.monitor)
        this.init()
    },
    methods :{
        ...mapActions(['actmutJsonData','actmutcourseJson']),
        isHisteryListMsg(){
            if(this.courseJsonDate.isProhibit){
                this.isMgsDisable = true
            }else{
                this.isMgsDisable = false
            }
        },
        init(){
            // 计算聊天区高度
            if(this.isPC){
                this.box_height()
            }else{
                this.box_heightpc()
            }
            if (this.environment() != 'miniprogram' && this.environment() != 'weixinBrowser'){
                this.$http(`${this.hosturl}/course/network_time/`).then(res => {
                    let data = res.data
                    if(data.code == 200){
                        if (!this.nowDate) {
                            this.nowDate = moment(data.result.current_time).valueOf();
                            setInterval(() => {
                                this.nowDate = this.nowDate + 1000;
                            }, 1000)
                            this.getJsonInfo();
                        }
                    }
                })
                .catch(error => {
                    if (!this.nowDate) {
                        this.nowDate = new Date().valueOf();
                        setInterval(() => {
                            this.nowDate = this.nowDate + 1000;

                        }, 1000)
                        this.getJsonInfo();
                    }
                })
                setTimeout(() => {
                    if (!this.nowDate) {
                        this.nowDate = new Date().valueOf();
                        setInterval(() => {
                            this.nowDate = this.nowDate + 1000;

                        }, 1000)
                        this.getJsonInfo();
                    }
                }, 5000);
            }else{
                if(this.environment() == 'weixinBrowser'){  //在小程序中 不可打开
                    this.isShowWX = true
                }else if(this.environment() == 'miniprogram'){//微信中打开，提示在浏览器中打开
                    this.isShowWX = true
                }
            }
        },
        getJsonInfo(){ //获取默认json
            if (window.localStorage.getItem('userIds')) {
                this.currentUserId = window.localStorage.getItem('userIds');
                this.userInfo.id = window.localStorage.getItem('userIds');
            } else {
                this.currentUserId = this.randomStringSocket(18);
                window.localStorage.setItem('userIds', this.currentUserId);
                this.userInfo.id = this.currentUserId;
            }
            if(window.localStorage.getItem('admNickname')){
                this.userInfo.nickname = window.localStorage.getItem('admNickname');
            }else{
                window.localStorage.setItem('admNickname', this.userInfo.id);
                this.userInfo.nickname = this.userInfo.id
            }
            // var href =  window.location.href;
            // var liveids = this.$utils.parseQueryString(href) //获取浏览器 问号后所有参数 
            var href =  window.location.pathname;
            var liveids = href.replace(/\//g,'')
            console.log(liveids)

            var url = ''
            if(liveids){
                // url = `https://atomy.youinsh.cn/json/${liveids}/atomy.json?${new Date().valueOf()}`
                url = `https://atomy.youinsh.cn/${liveids}/static/json/atomy.json?${new Date().valueOf()}`
                // https://atomy.youinsh.cn/25643/static/json/atomy.json
            }else{
                url = `https://atomy.youinsh.cn/live-atomy/js/atomy.json?${new Date().valueOf()}`
            }
            console.log(url)
            // url = `https://atomy.youinsh.cn/json/8430/atomy.json?${new Date().valueOf()}`
            // url = '../static/json/atomy.json'
            // console.log(url)
            this.$http(url).then(res => {
                let data = res.data
                this.courseInfo = data
                // this.videoUrl = data.url_hls1
                console.log(data)
                if(data.isRemMsg){
                    this.isRemMsg = data.isRemMsg // 爱在线=1, 一日研讨会=0   修改昵称文案不同
                }
                this.getCourseJson(data.liveid2)
                this.initWebSocket()
                chatJS.init(this);
                this.actmutJsonData(data) //往vuex里存了一下
            })
        },
        firstIntoPlayer(){ //首次进入的时候 
            this.videoOption = {
                id: "play-con",
                source: this.courseInfo.url_hls1,
                width: "100%",
                height: this.isMobile()?"56.25vw":'100%',
                autoplay: false,
                isLive: this.courseInfo.isLive,
                x5_type: "h5_page",
                playsinline: true, // H5是否内置播放
                poster: this.courseInfo.image,
                cover:this.courseInfo.image, //封面地址
                playType: 'hls',
                controlBarVisibility: "click" /* The mode of the status bar, which is set to Click. */,
                showBarTime: "10000" /* The time period that you must wait before the status bar is hidden, which is set to 10,000 milliseconds. */
            };
            this.content = 'play-con';
            this.mask = 'playmask';
            var nowdate = this.nowDate;
            if (moment(this.courseInfo.start_time).valueOf() - nowdate <= this.courseInfo.delayTime && moment(this.courseInfo.end_time).valueOf() - nowdate >= 0) {
                console.log("---00000--直播开始啦")
                this.livePlayerStatus = 2
                if (!this.videoPlayer) {
                    if (!this.videoPlayer) {
                        this.newPlayer(this.videoOption, this.content);
                    }
                }
            }
            if (moment(this.courseInfo.end_time).valueOf() - nowdate < 0) {
                console.log("直播已结束---时间计算的")
                this.livePlayerStatus = 0
            }
            if (moment(this.courseInfo.start_time).valueOf() - nowdate > 0) {
                let diffTime = moment(this.courseInfo.start_time).valueOf() - nowdate;
                if (diffTime > 0) {
                    console.log("-----直播倒计时")
                    this.recordTimer = setInterval(() => {
                        this.recordTiming(this.courseInfo.start_time); //倒计时
                    }, 1000)
                }
            }
        },
        getNotSpeak(liveid){
            let _that = this
            // console.log(this.currentUserId)
            this.$http(`${_that.hosturl}/controller/system/get_kickout_forbidden_list/${liveid}/`).then(res => {
                var data = res.data
                if(data.code == 200){
                    let forbiddenUsers = data.result.forbiddenUsers //禁言列表
                    let kickOutUsers = data.result.kickOutUsers //黑名单 无权观看
                    kickOutUsers.forEach((item,index) => {
                        if(item == _that.currentUserId){
                            window.location.href = 'https://atomy.youinsh.cn/blacklist/'
                            // _that.isBlackNameList = true //黑名单
                        }
                    })
                    forbiddenUsers.forEach((item,index) => {
                        if(item == _that.currentUserId){
                            _that.courseJsonDate.isProhibit = true //禁言中
                        }
                    })
                }
            })
        },
        getCourseJson(liveid){ //
            var course_json_nameUrl = `${this.baseurlJson}/json/course_${liveid}_info.json?${new Date().valueOf()}`
            this.$http(course_json_nameUrl).then(res => {
                // console.log(res)
                let data = res.data
                this.courseJsonDate = data
                this.videoUrl = data.url_hls
                this.courseInfo.url_hls1 = data.url_hls
                this.courseInfo.image = data.image
                this.courseInfo.chat_room_id = data.chat_room_id
                this.getNotSpeak(data.id)
                // isProhibit 是否全部禁言
                this.actmutcourseJson(data) //vuex里存了一下
                let live_menus = data.live_menus
                this.menuTab = []
                let menulist = live_menus.filter((item) => {
                    return item.isShow
                })
                this.menuTab = menulist
                // this.menuTab.push({name:"直播简介",isShow:true,code:'liveBrief'})
                if(this.menuTab.length){
                    this.tab = this.menuTab[0]
                    this.tabMenu(0,this.menuTab[0])
                }
                if(data.limitType == 'password'){
                    if(sessionStorage.getItem("passwordAtom") == data.code){
                        this.firstIntoPlayer()
                        this.initLeancloudinit(this.courseInfo.chat_room_id)
                    }else{
                        this.passwordWatch = true
                    }
                }else{
                    this.firstIntoPlayer()
                    this.initLeancloudinit(this.courseInfo.chat_room_id)
                }
                
                // console.log(this.menuTab)
                
            })
        },
        newPlayer(option, content){ //实例化播放器
            let _that = this
            console.log(option, content)
            _that.videoPlayer = new Aliplayer(option, function (player) {
                $(".prism-cc-btn").hide();  //播放器组件
                $(".prism-setting-btn").hide();//播放器组件
                // 只显示音量跟全屏按钮
                // $("#play-con").removeAttr("style");
                player.on("liveStreamStop", function () {
                    console.log("直播失败或直播已结束");
                    _that.disposePlayer(content);
                });
                player.on("ready", function () {
                    let plaCon = document.getElementsByTagName('video');
                    // plaCon[0].setAttribute("webkit-playsinline",true)
                    // plaCon[0].setAttribute("x5-video-player-type",'h5')
                    // plaCon[0].setAttribute("x5-video-orientation",'portraint')
                    // plaCon[0].setAttribute("controls",'')
                    // console.log(plaCon[0],'====---===') 
                });
                // 视频出错
                player.on("error", function () {
                    console.log("出错");
                    _that.disposePlayer(content);
                });
                if (_that.websocket && _that.videoPlayer && _that.videoPlayer._status == "playing") {
                    _that.websocket.send(JSON.stringify({ "type": "record", "msg_type": "start", "msg": { "duration": 0, "enterprise_id": 2159 } }
                    ))
                }
                setInterval(() => {
                    if (_that.websocket && _that.videoPlayer && _that.videoPlayer._status == "playing") {
                        _that.websocket.send(JSON.stringify({ "type": "record", "msg_type": "end", "msg": { "duration": 10, "enterprise_id": 2159 } }))
                    }

                }, 10000)

            });
        },
        disposePlayer(content) { //销毁播放器
            this.videoPlayer.dispose();
            this.videoPlayer = "";
            this.livePlayerStatus = 1
            console.log("销毁播放器")
        },
        initWebSocket(){
            var _that = this
            let webSocketPath = "wss://socket-test.youinsh.net:9100/youin" + '/'+ _that.courseInfo.liveid1 +'/' + _that.currentUserId + "/";
            _that.websocket = new WebSocket(webSocketPath);
            let websocket = _that.websocket
            
            //连接成功建立的回调方法
            websocket.onopen = function (event) {
                console.log("WebSocket:已连接");
                //心跳检测重置
                // heartCheck.reset().start();
            };

            //接收到消息的回调方法
            websocket.onmessage = function (event) {
                //showNotify(event.msg);
                console.log("WebSocket:收到一条消息", event.data);
                var msg = JSON.parse(event.data); //解析收到的json消息数据

                // heartCheck.reset().start();
            };

            //连接发生错误的回调方法
            websocket.onerror = function (event) {
                console.log("WebSocket:发生错误");
                _that.reconnect();
            };

            //连接关闭的回调方法
            websocket.onclose = function (event) {
                console.log("WebSocket:已关闭");
                // heartCheck.reset(); //心跳检测
                _that.reconnect();
            };

            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function () {
                websocket.close();
            };

            //关闭连接
            // function closeWebSocket() {
            //     websocket.close();
            // }


        },
        reconnect(){ //重连 WebSocket
            let _that = this
            if (_that.lockReconnect) {
                return;
            }
            _that.lockReconnect = true;
            _that.timerWebSocket && clearTimeout(_that.timerWebSocket);
            _that.timerWebSocket = setTimeout(function () {
                console.log('重连中...');
                _that.lockReconnect = false;
                _that.initWebSocket();
            }, 30000);
        },
        initLeancloudinit(chat_room_id){
            let _that = this
            chatJS.initLeancloud(chat_room_id, _that.userInfo);
        },
        historyChatHandFn(list){ //历史消息
            this.chatList = list
            this.$nextTick(() => {
                if(this.isPC){
                    this.box_height()
                }else{
                    this.box_heightpc()
                }
                this.scrollToBottom()
            })
            this.isHisteryListMsg()
        },
        reamtimeChatHandFn(list){ //自己发送的消息
            // console.log("----")
            this.chatList.push(list)
            this.scrollToBottom()
        },
        sendNews(){ //发送消息
            let str = this.chatmsg.trimStart(); //去除前空格;
            let niclocalname = window.localStorage.getItem('admNickname');
            if(this.userInfo.id == niclocalname){ //发送消息 判断是否有昵称
                this.isShowNickname = true
                this.userInfo.nickname = ''
                return 
            }
            if(str){
                chatJS.putTextFn(str,this.courseJsonDate.isProhibit);
                this.chatmsg = ""
            }else{
                if(this.courseJsonDate.isProhibit){
                    Toast('您被禁言中')
                    return
                }
                this.chatmsg = ""
                Toast('请输入您要发送的内容')
            }
        },
        beforeUploadImg(field){ //聊天上传图片
            console.log(field)
            chatJS.putImgFn(field.file, this.courseJsonDate.isProhibit);
        },
        nickNameChange(){ //输入昵称
            let str = this.userInfo.nickname.trimStart(); //去除前空格;
            let strend = str.trimEnd()
            var nickname = strend.substring(strend.length - 6)*1
            if(!strend){
                Toast('请输入一个昵称吧')
                return 
            }
            // console.log(nickname)
            // console.log(nickname+''.length)
            if(nickname){
                this.userInfo.nickname = strend
                window.localStorage.setItem('admNickname', strend);
                chatJS.exitRoom();
            }else{
                Toast('您的昵称输入有误 请加上真实手机号后6位')
            }
        },
        clientWidth() {
            return document.documentElement.clientWidth < 750 ? document.documentElement.clientWidth : 750;
        },
        clientHeight() {
            return document.documentElement.clientHeight;
        },
        box_height() {
            let clientWidth = this.clientWidth();
            let clientHeight = this.clientHeight();
            let ch = (clientHeight * 750) / (clientWidth * 100);
            let h = 56.25 * 7.5
            var videoHeight = 0 //播放器高度
            // livePlayerStatus:1 ,// 直播状态  1直播未开始 0直播已结束 2直播进行中
            if(this.livePlayerStatus == 2){
                videoHeight = document.getElementById('play-con').offsetHeight
            }else{
                videoHeight = document.getElementById('playmask').offsetHeight
            }
            var titleHead = document.getElementsByClassName('title-atomy')[0].offsetHeight //标题高度
            var titleTab = document.getElementsByClassName('tab')[0].offsetHeight //tab栏高度
            var footerChat = document.getElementsByClassName('footer-chat')[0].offsetHeight //footer高度
            var allHeight = videoHeight+titleHead+titleTab+footerChat 
            this.chatHeight = (clientHeight - allHeight).toFixed(0)  //聊天区的高度
            // console.log(clientWidth,clientHeight,ch,videoHeight,titleHead,titleTab,footerChat)
            // console.log(((clientHeight - allHeight).toFixed(0)))
            // return (ch - h).toFixed(2)
        },
        box_heightpc(){
            let clientWidth = this.clientWidth();
            let clientHeight = this.clientHeight();
            let ch = (clientHeight * 750) / (clientWidth * 100);
            let h = 56.25 * 7.5
            var videoHeight = 0 //播放器高度
            // livePlayerStatus:1 ,// 直播状态  1直播未开始 0直播已结束 2直播进行中
            if(this.livePlayerStatus == 2){
                videoHeight = document.getElementById('play-con').offsetHeight
            }else{
                videoHeight = document.getElementById('playmask').offsetHeight
            }
            var titleHead = document.getElementsByClassName('title-atomy')[0].offsetHeight //标题高度
            var titleTab = document.getElementsByClassName('tab')[0].offsetHeight //tab栏高度
            var footerChat = document.getElementsByClassName('footer-chat')[0].offsetHeight //footer高度
            var allHeight = titleTab+footerChat +40 
            this.chatHeight = (clientHeight - allHeight).toFixed(0)  //聊天区的高度
        },
        scrollToBottom(env,val){
            this.$nextTick(() => {
                this.$refs.virtualListTemple.scrollToBottom()
            })
        },
        renderingFn(content){ //发送题目，显示答题卡
            this.winninganswer = content
            this.isShowAnswer = true
        },
        recordTiming(startTime) { //倒计时
            let nowTime = this.nowDate;
            let diff = moment(startTime).valueOf() - nowTime;
            // console.log(diff)
            // console.log(diff <= this.courseInfo.delayTime)
            if (diff <= this.courseInfo.delayTime) {
                // console.log("d倒计时---2")
                clearInterval(this.recordTimer);
                this.livePlayerStatus = 2
                if (!this.videoPlayer) {
                    this.newPlayer(this.videoOption, 'play-con');
                }
            } else {
                var dd = moment.duration(diff).days().toString(),
                    hh = moment.duration(diff).hours().toString(),
                    mm = moment.duration(diff).minutes().toString(),
                    ss = moment.duration(diff).seconds().toString();
                this.countFownTime = dd +'天'+ hh +'时'+ mm +'分'+ ss +"秒"
            }
        },
        isMobile() {
            var e = navigator.userAgent.toLowerCase()
            var t = /iPhone|iPad|iPod/i.test(e),
                n = /Android/i.test(e),
                r = /Windows Phone/i.test(e) || /IEMobile/i.test(e) || /WPDesktop/i.test(e),
                a = /BlackBerry/i.test(e),
                o = /Opera Mini/i.test(e);
            return t || n || r || a || o || (this.isWeixinBrowser && (window.innerWidth < 768))
        },
        isWeixinBrowser() {
            return /micromessenger/.test(navigator.userAgent.toLowerCase())
        },
        environment(){ // 当前运行环境，返回值miniprogram表示在微信小程序，weixinBrowser表示在微信浏览器，APP表示是APP环境
            let envir;
            const ua = navigator.userAgent.toLowerCase();
            // 判断是否在微信或者微信小程序中
            if (/mobile/.test(ua)) {
                if (/micromessenger/.test(ua)) {
                if (/miniprogram/.test(ua)) {
                    envir = "miniprogram";
                } else {
                    envir = "weixinBrowser";
                }
                } else {
                envir = "APP";
                }
            }
            return envir;
        },
        isJSON(str) { //判断数据类型
            if (typeof str == "string") {
                try {
                    if (typeof JSON.parse(str) == 'object') {
                        return JSON.parse(str);
                    } else {
                        return false;
                    }
                } catch (e) {
                    return false;
                }
            }
        },
        getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].trim();
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        },
        randomStringSocket(len) {
            len = len || 32;
            var $chars = 'abcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            var maxPos = $chars.length;
            var pwd = '';
            for (var i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        tabMenu(index,item){  //tab切换
            if(item.type == '自定义菜单' || item.type == '自定义图文'){
                this.isUserDefined = true
            }else{
                this.isUserDefined = false
            }
            this.tab = item
        },
        closeprizeQA(){ //关闭答题
            this.isShowAnswer = false
            this.isShowAnswerRankingList = false
        },
        showAnswerList(){ //显示总排行榜
            this.isShowAnswer = true
            this.isShowAnswerRankingList = true
        },
        changetypepage(data){
            this.answerPageType = data
        },
        utiljstime(data){ //开播时间
            let timerdata = this.$utils.getDate(data)
            return timerdata.n +'-'+ timerdata.y +'-'+ timerdata.r +' '+ timerdata.h +':'+ timerdata.f +':00'
            // console.log(timerdata)
        },
        monitor(e) {
            let isExist = e.target.visibilityState
            console.log(isExist)
            if (isExist === 'visible') {
                // console.log(new Date().toLocaleString(), `您已进入页面！`)
                // this.getCourseJson(this.courseInfo.liveid2)
            } else {
                // console.log(new Date().toLocaleString(), `您已离开页面！`)
            }
        },
        changeNickname(){ //弹出修改昵称弹框
            if(!this.passwordWatch){
                this.isShowNickname = true
                let username = window.localStorage.getItem('admNickname')
                let userid = window.localStorage.getItem('userIds')
                if(username == userid){
                    this.nickNameTitle = '请输入昵称'
                }else{
                    this.nickNameTitle = '修改昵称'
                    this.userInfo.nickname = username
                }
            }else{
                Toast("请您输入正确观看密码！")
            }
            
        },
        cancelNickname(){ //关闭弹出修改昵称弹框
            this.isShowNickname = false
            this.userInfo.nickname = ""
        },
        passWatch(){ //加密直播确定按钮
            if(this.passwordCode){
                let me5Code = md5(this.passwordCode)
                if(me5Code == this.courseJsonDate.code){
                    this.passwordWatch = false
                    sessionStorage.setItem("passwordAtom", me5Code);
                    this.firstIntoPlayer()
                    this.initLeancloudinit(this.courseInfo.chat_room_id)
                }else{
                    Toast("密码错误哦～")
                }
            }else{
                Toast("请输入本场直播的直播密码～")
            }
            
        }
    },
    filters:{
        playerStatusmsg(active){//直播状态
            // console.log(active)
            switch (active) {
                case 0:
                    active = '直播已结束';
                    break;
                case 1:
                    active = '敬请期待';
                    break;
                case 2:
                    active = '直播进行中';
                    break;
            }
            return active
        }
    },
    components:{
        videoPage,
        VirtualList,
        prizeQA
    },
    computed: {
        ...mapState({
            hosturl :state => state.global.baseUri,
            baseurlJson :state => state.global.baseurlJson,
        })
    },
    destroyed(){
        document.removeEventListener('visibilitychange', this.monitor)
    }
}
</script>
<style scoped lang="scss" >
    // 省略号
    @mixin ellipsis($num){
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: $num;
        line-clamp: $num;
        -webkit-box-orient: vertical;
    }
    .video-phone{
        position:relative;
        width:100%;
        height:56.25vw;
        overflow: hidden;
        .absovideo-phone{
            position: absolute;
            width:100%;
            height:100%;
        }
    }
    .playmask{
        // position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height:56.25vw;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        z-index: 9;
        .bgcolor{
            width: 100%;
            height: 56.25vw;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: cover;
            background-color: rgb(0, 0, 0, 0.2);
            text-align:center;
        }
        .timer{
            margin-top:30%;
            margin-bottom:.1rem;
        }
        .playerStatus,.timer{
            color:#ffffff;
            font-size:.12rem;
            letter-spacing: .04rem;
        }
    }
    .title-atomy{
        background:#ffffff;
        padding:.1rem;
        height:.52rem;
        // box-sizing: border-box;
        border-bottom:.01rem solid rgba(223, 224, 230, .6);
        display:flex;
        img{
            width:.32rem;
            height:.32rem;
            box-shadow: .01rem .01rem .06rem rgba(136,136,136,.6);
            margin-right:.14rem;
            border-radius:50%;
        }
        span{
            display:inline-block;
            color:#999999;
            font-size:.12rem;
        }
        .title-atomy-msg-title{
            color:rgba(0,0,0,.7);
            font-size:.14rem;
            font-weight: 600;
            padding-bottom:.04rem;
            @include ellipsis(1);
        }
    }
    .tab{
        padding:.1rem;
        height:.4rem;
        overflow: hidden;
        // box-shadow: .0rem .0rem .0rem .01rem rgba(136,136,136,.3);
        background:#ffffff;
        margin-bottom:.02rem;
        span{
            margin-right:.26rem;
            color:#999;
            display:inline-block;
            position:relative;
            font-size:.12rem;

        }
        .tab-active::after{
            content:"";
            position:absolute;
            left:5%;
            bottom:-.16rem;
            height:.02rem;
            background-color:#1994FF;
            width:90%;
        }
        .tab-active{
            color:#1994FF;
            font-weight: 600;;
        }
        .tab-menu-list{
            display:flex;
        }
    }
    .tab-box{
        margin-bottom:.48rem;
        flex: 1;
        width:100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch
    }
    .tab-introduce{
        padding:20px 10px;
        font-size:14px;
        &>>> p{
            color:#999999;
            line-height:.22rem;
        }
        
    }
    .footer-chat{
        display:flex;
        background:#ffffff;
        width:100%;
        height:.48rem;
        position:fixed;
        bottom:0;
        left:0;
        padding:.1rem;
        // box-sizing: border-box;
        .updateimg-chat{
            &>>> .van-uploader__upload{
                width:.22rem;
                height:.26rem;
                margin:0 .00rem;
            } 
        }
        .footer-input{
            flex-grow: 2;
            margin-right:.1rem;
            display:flex;
            justify-content: space-between;
            &>>>.van-cell-group--inset{
                margin:0;
                flex-grow: 1;
            }
            &>>>.van-cell{
                padding:0 .1rem;
                margin:0;
                line-height:.3rem;
            }
            .icon-changename{
                margin-right:.06rem;
            }
            .icon-changename > .van-icon{
                font-size:.28rem;
                color:#666666;
            }
        }
        .up-pic{
            display:inline-block;
            position:relative;
            width:.22rem;
            height:.26rem;
            .update-img{
                position:absolute;
                font-size:.24rem;
                top:.04rem;
            }
            .updateimg-chat{
                position:absolute;
                opacity: 0;
                z-index:1;
            }
        }
        .footer-show-box{
            display:flex;
            div{
                margin-right:.08rem;
            }
            div:last-child{
                margin-right:0;
            }
        }
        .send-msg{
            background:#1994FF;
            padding:.06rem .1rem;
            color:#ffffff;
            border-radius:.06rem;
            margin-top:.04rem;
        }
        &>>>.van-cell{
            background:#F2F2F2;
            color:#333333;
        }
    }
    .wechattips{
        position: fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:1001;
        img{
            width:100%;
            height:100%;
        }
    }
    .dt_phb_box{
        display:flex;
        justify-content: end;
        margin-right:.1rem;
        position:fixed;
        right:.1rem;
        bottom:.76rem;
        img{
            width:.4rem;
        }
    }
    .userName-chat,.password-watch{
        width:100%;
        height:100%;
        position:fixed;
        left:0;
        top:0;
        background:rgba(51,51,51,.3);
        display:flex;
        align-items:start;
        justify-content:center;
        z-index: 1001;
        text-align:center;
        z-index:2001;
        position: fixed;
        .username-pop{
            background:#ffffff;
            // padding:.1rem;
            border-radius: .04rem;
            width:80%;
            max-width:3rem;
        }
        .user-pop-title{
            margin-bottom:.14rem;
            font-weight: 600;
            padding:.1rem;
        }
        &>>>.van-cell-group--inset{
            margin-bottom:.16rem;
            padding:0 .1rem;
        }
        &>>>.van-cell{
            background:#ffffff;
            color:#333333;
            border:.01rem solid rgba(153, 153, 153, .5);
            border-radius:.04rem;
        }
        &>>>.van-hairline--top-bottom::after{
            border: none;
        }
        .nickname-sure{
            display:flex;
            border-top:.01rem solid #DFE0E6;
            justify-content:space-between;
            span{
                color:#1994FF;
                flex-grow: 1;
            }
            height:.4rem;
            line-height:.4rem;
            .cancelNickname{
                color:#333333;
                border-right: .01rem solid rgba(153, 153, 153, .5);
            }
        }
        .usernamePrompt{
            font-size:.12rem;
            color:#999999;
            padding:0 .26rem;
            text-align:left;
            margin-bottom:.24rem;
            line-height:.16rem;
            i{
                color:#FF0F0F;
            }
        }
    }
    .max-section{
        .userName-chat{
            height:calc(100% - 56.25vw);
            position:fixed;
            left:0;
            top:56.25vw;
            overflow-y: scroll;
        }
    }
    .pcmax-section{
        background:#000000;
        position:absolute;
        width:100%;
        height:100%;
        .userName-chat{
            align-items:center;
        }
    }
    .isBlackClass{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background:#ffffff;
        display:flex;
        flex-direction:column;
        justify-content:center;
        text-align:center;
        z-index:1001;
        img{
            width:1.6rem;
        }
        div{
            margin-bottom:.1rem;
            color:#a8aaaf;
        }
    }
    .pclass{
        display:flex;
        width:100%;
        height:100%;
        padding:.2rem .1rem;
        .video-content,.playmask{
            height:41.2vw;
        }
        .pc-left{
            flex-grow:1;
            background:#30323D;
            margin-right:.1rem;
            border-radius:.04rem;
            overflow:hidden;
        }
        .video-content{
            // padding:.1rem;  
        }
        .pc-right{
            width:2.8rem;
        }
        .footer-chat{
            position:inherit;
        }
        .pc-right{
            // padding:0rem 0rem .1rem 0;
            position:relative;
            background:#30323D;
            border-radius :0.04rem;
            overflow:hidden;

        }
        
        .footer-chat{
            position:absolute;
            bottom:0;
            left:0;
        }
        .title-atomy{
            background:#30323D;
            border-top-right-radius:.04rem;
            border-top-left-radius:.04rem;
            border-bottom:none;
            span{
                color:#ffffff;
            }
        }

        .tab{
            background:none;
            box-shadow:none;
            border-bottom:.01rem solid rgba(255,255,255,.3);
            div{
                display:flex;
            }
            .tab-active{
                color:#1994FF;
            }
            span{
                font-size:.12rem;
            }
        }
        .tab div{
            span{
                flex-grow:1;
                text-align:center;
            }
        }
        .tab .tab-active::after{
            bottom:-.17rem;
        }
        .footer-chat{
            background:#30323D;
            border-top:.01rem solid rgba(255,255,255,.3);
            &>>>.van-cell{
                background:#505466;
            }
            &>>>.van-hairline--top-bottom::after{
                border:none;
            }
            &>>>.van-field__control{
                color:#ffffff;
            }
            &>>>.van-cell-group{
                background:none;
            }
            .icon-changename .van-icon{
                color:rgba(255,255,255,.7);
            }
        }
        .footer-chat .footer-show-box div{
            color:#ffffff;
        }
        .prism-player{
            background:#30323d;
            border-bottom-right-radius:.04rem;
            border-bottom-left-radius:.04rem;
        }

    }
    .password-watch{
        align-items:center;
        .usernamePrompt{
            text-align:center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Apage/index.vue